import { formatMoney } from '../../utils/currency';

let theme = window.theme || {};
let Shopify = window.Shopify || {};

/**
 * Handle several analytics and pixel events when an new item is added to the cart.
 * It isn't called under edit cart item scenarios
 * @param {Shopify Cart Object} cart - Shopify Cart Liquid Object https://shopify.dev/docs/api/liquid/objects/cart
 * @param {HTML form} form - HTML form node
 * @returns
 */
export default function (cart, form) {
  if (!form) {
    return;
  }

  const element = form;
  const dataAttribute = element && element.getAttribute('data-form-template');
  const productIdAttribute = element && element.getAttribute('data-product-id');
  const variantIdAttribute = element && element.getAttribute('data-variant-id');

  if (variantIdAttribute && productIdAttribute) {
    window.monetateQ.push([
      'addProductDetails',
      [
        {
          productId: productIdAttribute.toString(),
          sku: variantIdAttribute.toString(),
        },
      ],
    ]);
  }

  var cartProductIds = [];
  if (dataAttribute) {
    if (dataAttribute.includes('ajax')) {
      // means its coming from quickview
      window.monetateQ.push(['setPageType', 'quickview']);

      var cartItems = cart.items;

      var cartData = [];
      for (var i = 0; i < cartItems.length; i++) {
        var cartItem = cartItems[i];
        var price = formatMoney(cartItem.price, theme.moneyFormat);
        price = price.replace(/[$A-Za-z,\s]+/g, '');
        if (!/^\d/.test(price)) {
          price = price.slice(1);
        }
        var cartItemData = {
          productId: cartItem.product_id.toString(),
          quantity: cartItem.quantity.toString(),
          unitPrice: price,
          currency: Shopify.currency.active.toString(),
          sku: cartItem.variant_id.toString(),
        };
        cartData.push(cartItemData);
        cartProductIds.push(cartItem.product_id);
      }

      window.monetateQ.push(['addCartRows', cartData]);

      window.monetateQ.push(['trackData']);

      window.FastSimonSDK.event({
        eventName: window.FastSimonEventName.AddToCartPerformed,
        reportAppType: 'SPA',
        data: {
          productID: [...cartProductIds], // (Required)
        },
      });
    } else {
      if (!window.location.href.includes('cart')) {
        window.monetateQ.push(['setPageType', 'product']);
        cartItems = window.cart.items;

        cartData = [];
        for (i = 0; i < cartItems.length; i++) {
          cartItem = cartItems[i];
          price = formatMoney(cartItem.price, theme.moneyFormat);
          price = price.replace(/[$A-Za-z,\s]+/g, '');
          if (!/^\d/.test(price)) {
            price = price.slice(1);
          }
          cartItemData = {
            productId: cartItem.product_id.toString(),
            quantity: cartItem.quantity.toString(),
            unitPrice: price,
            currency: Shopify.currency.active.toString(),
            sku: cartItem.variant_id.toString(),
          };
          cartData.push(cartItemData);
          cartProductIds.push(cartItem.product_id);
        }

        window.monetateQ.push(['addCartRows', cartData]);

        window.monetateQ.push(['trackData']);

        window.FastSimonSDK.event({
          eventName: window.FastSimonEventName.AddToCartPerformed,
          reportAppType: 'SPA',
          data: {
            productID: [...cartProductIds], // (Required)
          },
        });
      }
    }
  }

  // we will set window.cart here because we are bringing the entire cart data from Shopify server
  window.cart = cart;
}
